<script lang="ts">
  import Input from '$shared/atoms/Input/Input.svelte';
  import { InputType } from '$shared/constants/InputType';
  import type { SensitiveString } from '$provider/models/SensitiveString';
  import { onMount } from 'svelte';

  interface Props {
    sensitiveData?: SensitiveString | null;
    value?: string;
    label?: string;
    name?: string;
    placeholder?: string;
    disabled?: boolean;
    tabIndex?: number;
    required?: boolean;
    maxlength?: string;
    error?: string;
    showIcon?: boolean;
    noPermission?: boolean;
    onunmask?: (value: string) => void;
    oninput?: (detail: { value: string }) => void;
  }

  let {
    sensitiveData = null,
    value = $bindable(''),
    label = '',
    name = '',
    placeholder = '',
    disabled = false,
    tabIndex = 1,
    required = true,
    maxlength = '',
    error = $bindable(''),
    showIcon = true,
    noPermission = false,
    onunmask,
    oninput
  }: Props = $props();

  let passwordFieldType = $state(!showIcon ? InputType.Text : InputType.Password);
  let loading = $state(false);

  let iconValue = $derived(passwordFieldType === InputType.Password ? 'icon-eye' : 'icon-eye-off');

  onMount(() => {
    if (noPermission) {
      passwordFieldType = InputType.Password;
      return;
    }
    (async () => {
      await unmaskSensitveString();
    })();
  });

  const unmaskSensitveString = async () => {
    if (sensitiveData?.value && !sensitiveData.isUnmasked) {
      loading = true;
      await sensitiveData.unmaskAsync();
      value = sensitiveData.toString();
      onunmask?.(value);
      loading = false;
    }
  };

  const onUnMaskValue = () => {
    if (passwordFieldType === InputType.Password) {
      passwordFieldType = InputType.Text;
      return;
    }
    passwordFieldType = InputType.Password;
  };
</script>

<div class="input-wrap">
  <Input
    {required}
    type={passwordFieldType}
    icon={(showIcon && !noPermission && iconValue) || ''}
    {label}
    {name}
    {value}
    {placeholder}
    disabled={disabled || noPermission}
    {tabIndex}
    {maxlength}
    {error}
    {loading}
    onclickicon={onUnMaskValue}
    {oninput}
  />
</div>
